<template>
  <div class="my-setting">
    <basiCcontainer>
      <template #head>
        <div class="head-parent" >
          <div class="left">个人设置</div>
        </div>
      </template>
      <div class="from-box">
        <el-form :model="ruleForm" :hide-required-asterisk="true" :rules="userRules" size="large" label-position="top" ref="ruleForm">
          <el-form-item label-width="0px" prop="region">
            <div class="upload-img" @click="editAvatar">
              <Myavatar width="100px" height="100px" size="22px" :userName="userInfo.realname" :imgUrl="userInfo.user_avatar" class="avater-box" />
              <div class="upload-my-head">上传头像</div>
            </div>
          </el-form-item>
          <el-form-item label="姓名" prop="realname">
            <el-input v-model="ruleForm.realname" placeholder="请输入姓名" disabled maxlength="6"></el-input>
          </el-form-item>
          <el-form-item label="邮箱" prop="email">
            <el-input v-model="ruleForm.email" placeholder="请输入邮箱" disabled></el-input>
          </el-form-item>
          <el-form-item label="密码" prop="region">
            <el-input  placeholder="********" type="password" disabled>
              <span class="change-passwork letterHover" @click="restPassWork" slot="suffix">重置密码</span>
            </el-input>
          </el-form-item>
          <el-form-item label="手机" prop="phone">
            <el-input v-model="ruleForm.phone" placeholder="请输入手机" maxlength="11"></el-input>
          </el-form-item>
          <el-form-item label-width="0px" prop="region">
            <wf-button type="primary" class="save-btn" @click="save" :loading="saveLoading" auto size="large">保存</wf-button>
          </el-form-item>
        </el-form>
      </div>
    </basiCcontainer>
    <el-dialog title="头像更换" :visible.sync="cropperVisible" width="700px" :modal-append-to-body="true" :append-to-body="true">
      <AvatarCropper v-if="cropperVisible" @uploadSuccess="uploadSuccess" :avatarUrl="userInfo.user_avatar" :phone="ruleForm.phone"></AvatarCropper>
    </el-dialog>
    <ResetPasswordDialog v-model="showPass" :defaultMobile="defaultMobile"></ResetPasswordDialog>
  </div>
</template>
<script>
import { mapMutations, mapActions, mapGetters } from 'vuex'
import { Cookie } from '@/utils/utils'
import api from '@/services/api/mySetting/mySetting'
import { isEmail, isMobile, PassworkVali } from '@/utils/validate'
import AvatarCropper from "./avatarCropper"
import ResetPasswordDialog from './resetPassWordDialog'
export default {
  components: {
    AvatarCropper,
    ResetPasswordDialog
  },
  data() {
    const isEmailReg = (rule, value, callback) => {
      if (!isEmail(value)) {
        return callback(new Error('请输入正确的邮箱'));
      }
      callback();
    };
    const isMobileReg = (rule, value, callback) => {
      if (!isMobile(value)) {
        return callback(new Error('请输入正确的手机号'));
      }
      callback();
    };
    return {
      cropperVisible: false,
      showPass: false,
      passLoading: false,
      saveLoading: false,
      ruleForm: {
        realname: '',
        email: '',
        phone: ''
      },
      userRules: {
        realname: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
        email: [{ required: true, message: '请输入邮箱', trigger: 'blur' }, { validator: isEmailReg, trigger: 'blur' }],
        phone: [{ required: true, message: '请输入手机号', trigger: 'blur' }, { validator: isMobileReg, trigger: 'blur' }]
      }
    }
  },
  computed: {
    ...mapGetters('layout/layout', ["userInfo"]),
    defaultMobile() {
      return this.ruleForm.email ? this.ruleForm.email.slice(0, this.ruleForm.email.indexOf('@')) : ''
    }
  },
  created() {
    this.ruleForm.realname = this.userInfo.realname
    this.ruleForm.email = this.userInfo.email
    this.ruleForm.phone = this.userInfo.phone
  },
  mounted() {
  },
  methods: {
    ...mapActions('layout/layout', ['ChangePass', 'setUserInfo']),
    save() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.saveLoading = true
          let params = { ...this.ruleForm }
          params.uid = this.userInfo.uid
          params.depart_id = this.userInfo.depart_id
          params.usertype = this.userInfo.usertype
          params.status = this.userInfo.status
          api.updateSelfInfo(params).then(res => {
            this.saveLoading = false
            this.$alert('保存成功')
            this.setUserInfo()
          }).catch(err => {
            this.saveLoading = false
          })
        } else {
          this.saveLoading = false;
          return false;
        }
      });
    },
    editAvatar(e) {
      e.stopPropagation();
      this.cropperVisible = true;
    },
    uploadSuccess() {
      this.cropperVisible = false;
      this.setUserInfo()
    },
    restPassWork() {
      this.showPass = true
      // this.passwordForm = {
      //   newPass: '',
      //   againPass: ''
      // }
      // this.$refs['pass'].resetFields();
    }
  }
}
</script>
<style lang="scss" src="./style.scss">
</style>
